import React, {Component} from 'react';
import styles from "../../../InfoCliniche/InfoCliniche.module.css";
import Autocomplete from "../../../../../../components/autocomplete/Autocomplete";
import Input from "../../../../../../components/textbox/Input";
import {withTranslation} from "react-i18next";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import Utils from "../../../../../../utils/Utils";
import SelectAutocomplete from "../../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";

class SezioneUno extends Component {

    state = {
        sezioneUno: {
            ulss: "",
            regione: "",
            numeroCaso: "",
            corretto: []
        },
        regioni: OggettiUtili.Regioni
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.controllaDati = this.controllaDati.bind(this);
        this.createJsonBackend = this.createJsonBackend.bind(this)
    }

    componentDidMount() {
        let sezioneUno = this.state.sezioneUno
        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sezioneUno) {
            let propsSezioneUno = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.schedaSpeciale.sezioneUno));
            if (propsSezioneUno.regione && propsSezioneUno.regione.length===2){
                propsSezioneUno.regione=propsSezioneUno.regione.concat("0")
            }
            sezioneUno.regione = propsSezioneUno.regione ? OggettiUtili.Regioni[propsSezioneUno.regione] : this.state.sezioneUno.regione
            sezioneUno.ulss = propsSezioneUno.ulss ? OggettiUtili.ulssMap[propsSezioneUno.ulss].codice : ""
            sezioneUno.numeroCaso = propsSezioneUno.numeroCaso ? propsSezioneUno.numeroCaso : ""
        } else {
            sezioneUno.ulss = OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione] ? OggettiUtili.ulssMap[this.props.segnalazioneCopia.ulssSegnalazione].codice : ""
            sezioneUno.regione = OggettiUtili.Regioni["050"]
        }
        this.setState({sezioneUno: sezioneUno});

        this.controllaDati();
        this.props.setSezioneUno(this.state.sezioneUno)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.controllaDati()
        if (prevState !== this.state) {
            let res = this.createJsonBackend();
            this.props.setSezioneUno(this.state.sezioneUno, res)
        }
    }

    createJsonBackend() {
        let dati = JSON.parse(JSON.stringify(this.state.sezioneUno))
        let sezioneUnoBackend = Utils.removeEmptyValueFromObject(dati)
        if (dati.regione && dati.regione.codice) {
            dati.regione = dati.regione.codice
        }
        return Utils.removeFieldFromObject(sezioneUnoBackend, "corretto")
    }

    controllaDati() {

        let dati = this.state.sezioneUno
        dati.corretto = []

        if(!dati.ulss) dati.corretto[0] = "Campo \"ULSS\" mancante";
        if(!dati.numeroCaso) dati.corretto[1] = "Campo \"Numero Caso\" mancante";

    }

    riceviValore(field, event) {

        let sezioneUno = this.state.sezioneUno

        if(field && field.target && field.target.id){
            sezioneUno[field.target.id] = field.target.value
        }
        else{
            if (field === "numeroCasi") {
                sezioneUno.numeroCaso = event.target.value
            }
        }

        this.setState({sezioneUno: sezioneUno})
    }

    render() {

        const {t} = this.props

        let arrayUlss = [];
        Object.keys(OggettiUtili.ulssMap).map((key) => {
            arrayUlss.push(OggettiUtili.ulssMap[key]);
        });
        const sezioneUno = (
            <div>
                <div><h6>Sezione 1</h6>
                    <hr className={styles.hr}/>
                </div>
                <div className={"container"}>
                    <div>
                        <div className="row">
                            <div className="col-lg-6 mt-1">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                            <b>{t("SchedaEpatite.ulss")} </b>
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                    </div>
                                    <div className="col-lg-8">
                                        <SelectAutocomplete
                                            id={"ulss"}
                                            field={"ulss"}
                                            value={this.state.sezioneUno.ulss}
                                            onChange={this.riceviValore}
                                            disabled={(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione) || SessioneUtente.getInstance().ruoliUtente !== Ruoli.Operatore_Regionale.descrizione}
                                            functionMap={arrayUlss.map((oggetto) => {
                                                return (
                                                    <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                                            })}
                                        >
                                        </SelectAutocomplete>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6  mt-3">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                            <b>{t("SchedaEpatite.regione")} </b>

                                        </p>
                                    </div>
                                    <div className="col-lg-8">
                                        <Autocomplete
                                            field={"regione"}
                                            keyField={"codice"}
                                            descriptionField={"descrizione"}
                                            suggestionField={"descrizione"}
                                            value={this.state.sezioneUno.regione}
                                            suggestions={this.state.regioni}
                                            disabled={true}
                                            placeholder={t("SchedaEpatite.regione")}

                                        >
                                        </Autocomplete>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 mt-3">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <p className={styles.labelHeader} style={{marginTop: "10px"}}>
                                            <b>{t("SchedaEpatite.numeroCasi")} </b>
                                            <span className={styles.mandatoryColor}>*</span>
                                        </p>
                                    </div>
                                    <div className="col-lg-8">
                                        <Input id={"numeroCasi"}

                                               onChange={this.riceviValore}
                                               field={"numeroCasi"}
                                               errorMessage={"sezione non valido"}
                                               value={this.state.sezioneUno.numeroCaso}
                                               type={"number"}
                                               min={"0"}
                                               placeholder={"Numero caso"}>
                                        </Input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row" style={{marginTop: "10px"}}>
                            <p className={styles.labelHeader}>
                                <b><u>{t("SchedaEpatite.notaUno")}</u>
                                </b>

                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );


        return <div>

            {sezioneUno}
        </div>
    }


}

export default withTranslation('common')(SezioneUno)
